/**
 * Busca foto no productsMap com fallback parcial.
 * `productsMap` pode ter chaves por nome (lowercase) e por id (`id_<uuid>`).
 * Se não encontrar exato, tenta match parcial (substring nos 2 sentidos).
 */
export function findProductPhoto(name, productsMap) {
  if (!name || !productsMap) return null;
  const lower = name.toLowerCase().trim();
  if (productsMap[lower]) return productsMap[lower];
  for (const [key, url] of Object.entries(productsMap)) {
    if (key.startsWith("id_")) continue;
    if (key.includes(lower) || lower.includes(key)) return url;
  }
  return null;
}

/** Converte URL de foto (relativa ou /uploads) para URL absoluta via /api. */
export function getImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/uploads/")) return `/api${url}`;
  if (url.startsWith("uploads/")) return `/api/${url}`;
  return url.startsWith("/") ? `/api${url}` : url;
}
